module.exports = __webpack_public_path__ + "fonts/ralewaythinitalic.1873f71.woff2";